// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * Settings gear with a search/magnifying glass motif.
 * Fully Lucide-compatible (accepts all SVG props, inherits currentColor).
 */
export function SettingsCompareIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 15a3 3 0 1 1 3-3" />
      <path d="M12.5 21.927a2.34 2.34 0 0 1-2.829-2.064 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915 2.34 2.34 0 0 1 4.661 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0-.776.916" />
      <path d="m22 22-1.9-1.9" />
      <circle cx="18" cy="18" r="3" />
    </svg>
  );
}
